import {useState} from "react";
import { FaRegCircle, FaCircle } from 'react-icons/fa6';


function WordPair(props) {
   const [checked, setCheck] = useState(props.value);
   function onClick(e) {
      let value = !checked;
      setCheck(value);
      props.setValue(props.id,value);
   }  
   return (
      <div className="wordpair" onClick={onClick}>
         <span className={`wordPairCheck check columndata clickableArea${checked ? ' checked' : ''}`}>
            {checked?
               <FaCircle className="actionIcon" /> :
               <FaRegCircle className="actionIcon" />
            }
         </span >
         <span className="words">{props.word1} + {props.word2}</span>
      </div >   
   );
}

export default WordPair;